import React from 'react';
import PropTypes from 'prop-types';
import * as types from '../../../constants/actionTypes';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actions } from '../../../actions/locationTypeActions';
import LocationTypeForm from '../Identifiers/locationTypeForm';
import { DEFAULT_PAGE_SIZE } from '../../../constants/constants';
import { Dropdown } from 'primereact/dropdown';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Paginator } from 'primereact/paginator';
import Drawer from '../../Common/Drawer/Drawer';
import Icon from '../../Common/Icon';
import Notification from '../../../components/Common/Notification';
import LoadingIndicator from '../../Common/LoadingIndicator/LoadingIndicator';
import { getDataTableSortFields, getSearchParamSortFields } from '../../../helpers/sortHelper';

export class LocationType extends React.Component {
	constructor(props, context) {
		super(props, context);

		const newLocationType = {
			id: 0,
			name: '',
			isActive: true,
			subscriptionId: props.subscriptionId,
		};

		this.state = {
			locationTypes: [],
			totalCount: 0,
			selectedLocationType: newLocationType,
			editLocationType: newLocationType,
			newLocationType: newLocationType,
			drawerOpen: false,
			isFormValid: true,
			isFetching: false,
			isSaving: false,
			errorMessage: '',
			searchParams: {
				subscriptionId: props.subscriptionId,
				isActive: true,
				pageSize: DEFAULT_PAGE_SIZE,
				pageNumber: 1,
				sortBy: 'name',
				sortDir: 'asc',
				name: '',
			},
		};
		this.search.bind(this);
	}

	async componentDidMount() {
		await this.search();
	}

	async search() {
		try {
			this.setState({ isFetching: true });
			const result = await this.props.actions.searchLocationTypes(this.state.searchParams);
			const payload = result.payload;
			if (result.type === types.SEARCH_LOCATIONTYPE_SUCCESS) {
				this.setState({ locationTypes: payload.results, totalCount: payload.totalCount });
			} else if (result.type === types.SEARCH_LOCATIONTYPE_FAILURE) {
				Notification('error', 'An Error Occurred', payload.message);
			}
		} catch (error) {
			Notification('error', 'An Error Occurred', error);
		} finally {
			this.setState({ isFetching: false });
		}
	}

	async save() {
		try {
			this.setState({ isSaving: true });
			const result = await this.props.actions.saveLocationType(this.state.editLocationType);

			if (result.type === types.CREATE_LOCATIONTYPE_SUCCESS || result.type === types.UPDATE_LOCATIONTYPE_SUCCESS) {
				Notification('success', 'Save Successful', 'Location Type saved successfully');
				this.setState({ drawerOpen: false });
				this.setState({ searchParams: { ...this.state.searchParams, pageNumber: 1 } }, () => {
					this.search();
				});
			} else if (result.type === types.UPDATE_LOCATIONTYPE_FAILURE || result.type === types.CREATE_LOCATIONTYPE_FAILURE) {
				this.setState({ errorMessage: result.payload.message });
				Notification('error', 'An Error Occurred', result.payload.message);
			}
		} catch (error) {
			Notification('error', 'An Error Occurred', error);
		} finally {
			this.setState({ isSaving: false });
		}
	}

	filterNameChange = (e) => {
		this.setState({ searchParams: { ...this.state.searchParams, name: e.target.value } });
	};

	keyUpName = (e) => {
		if (e.keyCode == 13) {
			this.search();
		}
	};

	onSearchBlur = () => {
		this.search();
	};

	onActiveChange = (e) => {
		let raw = e.value;

		if (raw != null && typeof raw === 'object' && Object.prototype.hasOwnProperty.call(raw, 'value')) {
			raw = raw.value;
		}

		this.setState({ searchParams: { ...this.state.searchParams, isActive: raw } }, () => {
			this.search();
		});
	};

	onPageChange = (e) => {
		this.setState({ searchParams: { ...this.state.searchParams, pageNumber: e.page + 1 } }, () => {
			this.search();
		});
	};

	onAddNew = () => {
		this.setState({
			selectedLocationType: null,
			editLocationType: this.state.newLocationType,
			drawerOpen: true,
			errorMessage: '',
			isFormValid: true,
		});
	};

	onFormChange = (name, value) => {
		this.setState({ editLocationType: { ...this.state.editLocationType, [name]: value } });
	};

	// ------- Drawer
	saveClick = () => {
		const trimmedName = this.state.editLocationType.name.trim();

		if (trimmedName.length < 1) {
			this.setState({ isFormValid: false });
			return;
		}

		this.setState(
			(prevState) => ({
				isFormValid: true,
				editLocationType: {
					...prevState.editLocationType,
					name: trimmedName,
				},
			}),
			this.save
		); // Ensures `save` runs after the state is updated
	};

	cancelClick = () => {
		this.setState({ drawerOpen: false });
	};

	selectLocationType = (e) => {
		const newValue = e.value || this.state.selectedLocationType;
		this.setState({ selectedLocationType: newValue, editLocationType: newValue, drawerOpen: true, errorMessage: '', isFormValid: true });
	};
	// ------- Drawer

	actionTemplate = (rowData) => {
		if (rowData.isActive) {
			return (
				<div className='text-success text-center'>
					<Icon name='check-circle' />
				</div>
			);
		} else {
			return (
				<div className='text-danger text-center'>
					<Icon name='times-circle' />
				</div>
			);
		}
	};

	onSort = ({ sortField, sortOrder }) => {
		const { sortBy, sortDir } = getSearchParamSortFields(sortField, sortOrder);
		if (sortBy !== this.state.searchParams.sortBy || sortDir !== this.state.searchParams.sortDir) {
			this.setState(
				{
					searchParams: {
						...this.state.searchParams,
						sortBy: sortBy,
						sortDir: sortDir,
					},
				},
				this.search
			);
		}
	};

	render() {
		const activeOptions = [
			{ label: 'Yes', value: true },
			{ label: 'No', value: false },
			{ label: 'All', value: null },
		];
		const activeFilter = (
			<Dropdown className='ui-column-filter' value={this.state.searchParams.isActive} options={activeOptions} onChange={this.onActiveChange} />
		);

		const nameFilterElement = (
			<input
				type='text'
				className='p-inputtext'
				placeholder='Filter by Name'
				size='50'
				onBlur={this.onSearchBlur}
				onChange={this.filterNameChange}
				onKeyUp={this.keyUpName}
				value={this.state.searchParams.name}
			/>
		);
		const { sortField, sortOrder } = getDataTableSortFields(this.state.searchParams);

		return (
			<div>
				{this.state.drawerOpen ? (
					<Drawer isWide={false} title='Location Type' onSaveClick={this.saveClick} onCancelClick={this.cancelClick}>
						<LocationTypeForm
							locationType={this.state.editLocationType}
							onFormChange={this.onFormChange}
							isFormValid={this.state.isFormValid}
							onSubmit={this.saveClick}
						/>
					</Drawer>
				) : (
					''
				)}

				<LoadingIndicator isLoading={this.state.isFetching || this.state.isSaving} hideWhileLoading={true}>
					<div className=''>
						<div className='identifier-header'>
							<div className='title'>Type</div>
							<div className='close'>
								<button type='button' onClick={this.props.onClose} alt='close popup'>
									<Icon name='times' />
								</button>
							</div>
						</div>

						<div className='identifier-add-new'>
							<div className='col-sm-12'>
								<button type='button' className='btn btn-primary' onClick={this.onAddNew} alt='close popup'>
									<span className='me-2'>Add New</span>
									<Icon name='plus-circle' />
								</button>
							</div>
						</div>

						<div className='identifier-results-table'>
							<DataTable
								filterDisplay='row'
								className='p-datatable-sm p-datatable-striped'
								value={this.state.locationTypes}
								selectionMode='single'
								selection={this.state.selectedLocationType}
								onSelectionChange={this.selectLocationType}
								sortField={sortField}
								sortOrder={sortOrder}
								onSort={this.onSort}>
								<Column field='name' header='Name' sortable={true} filter={true} filterElement={nameFilterElement} />
								<Column
									field='isActive'
									header='Active'
									sortable={true}
									body={this.actionTemplate}
									style={{ width: '120px' }}
									filter={true}
									filterElement={activeFilter}
								/>
							</DataTable>
							{this.state.totalCount > this.state.searchParams.pageSize && (
								<Paginator
									rows={this.state.searchParams.pageSize}
									totalRecords={this.state.totalCount}
									first={(this.state.searchParams.pageNumber - 1) * this.state.searchParams.pageSize}
									onPageChange={this.onPageChange}
								/>
							)}
							<div className='results-count'>Total records: {this.state.totalCount}</div>
						</div>
					</div>
				</LoadingIndicator>
			</div>
		);
	}
}

LocationType.propTypes = {
	subscriptionId: PropTypes.number.isRequired,
	actions: PropTypes.object.isRequired,
	onClose: PropTypes.func.isRequired,
};

function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(actions, dispatch),
	};
}

export default connect(null, mapDispatchToProps)(LocationType);
